import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./PromoBanner.css";

const PromoBanner = ({ title, description, listItems, imageSrc, imageAlt }) => {
    return (
        <div className="promo-banner">
            <div className="promo-banner__content">
                <div className="promo-banner__text">
                    <h1 className="promo-banner__heading">{title}</h1>
                    {description && <p className="promo-banner__description">{description}</p>}

                    {listItems && listItems.length > 0 && (
                        <ul className="promo-banner__list">
                            {listItems.map((item, index) => {
                                const text = typeof item === 'object' ? item.text : item;
                                const icon = typeof item === 'object' ? item.icon : null;

                                return (
                                    <li key={index} className="promo-banner__list-item">
                                        {icon && (
                                            <FontAwesomeIcon
                                                icon={icon}
                                                className="promo-banner__icon"
                                            />
                                        )}
                                        {text}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
                <div className="promo-banner__image">
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        className="promo-banner__image-content"
                    />
                </div>
            </div>
        </div>
    );
};

export default PromoBanner;